"use client";

import { useEffect } from "react";

const enabled = false; // TODO: Check dates etc

export default function VisualEventsDisplay() {
  if (!enabled) {
    return <div />;
  }

  useEffect(() => {
    const displayConfetti = async () => {
      const { default: confetti } = await import("@hiseb/confetti");
      console.log("Displaying confetti animation");
      await new Promise((resolve) => setTimeout(resolve, 2000));

      for (let i = 0; i < 8; i++) {
        await new Promise((resolve) => setTimeout(resolve, 100 + Math.random() * 100));
        // get random value between 0 and window.innerWidth
        const randomX = Math.random() * window.innerWidth;
        const randomY = Math.random() * 100; // slight random Y offset
        confetti({
          position: { x: randomX, y: randomY }, // Origin position
          count: Math.random() * 66, // Number of particles
          size: 1, // Size of the particles
          velocity: 100 + Math.random() * 200, // Initial particle velocity
          fade: false // Particles fall off the screen, or fade out
        });
      }
    };
    displayConfetti();
    // window.addEventListener("load", displayConfetti);
    // return () => {
    //   window.removeEventListener("load", displayConfetti);
    // };
  }, []);
  return <div />;
}
